import type { AttributeCode } from '../state/attributeCode';
import type { CheckboxFilterValue } from '../state/checkbox';
import { CheckboxFilterStateMap } from '../state/checkbox';
import { extractAttributeCode, prefixAttribute } from './attributeCode';
import { HashMap, Schema, SchemaGetter } from 'effect';

const checkboxFilterStateMapToApiRecord = (
  filterStateMap: CheckboxFilterStateMap
): Record<string, string> =>
  HashMap.reduce(filterStateMap, {} as Record<string, string>, (acc, value, attributeCode) => {
    acc[prefixAttribute(attributeCode)] = String(value);
    return acc;
  });

const apiRecordToCheckboxFilterStateMap = (
  apiRecord: Record<string, string>
): CheckboxFilterStateMap => {
  let result = HashMap.empty<AttributeCode, CheckboxFilterValue>();
  for (const [prefixed, value] of Object.entries(apiRecord)) {
    const code = extractAttributeCode(prefixed);
    const booleanValue = value === 'true';
    result = HashMap.set(result, code, booleanValue);
  }
  return result;
};

export const CheckboxApiQuery = Schema.Record(Schema.String, Schema.String);

export const CheckboxToApi = Schema.toType(CheckboxFilterStateMap).pipe(
  Schema.decodeTo(CheckboxApiQuery, {
    decode: SchemaGetter.transform(checkboxFilterStateMapToApiRecord),
    encode: SchemaGetter.transform(apiRecordToCheckboxFilterStateMap),
  })
);
